/**
 * uuid
 */
export const uuid = () => {
  return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c) => {
    return (Number(c) ^ ((Math.random() * 16) >> (Number(c) / 4))).toString(16)
  })
}
